import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { GuildService } from '../services/guild.service';
import { BotGuild } from '../models/bot/guild';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class signupTemplateLimitsGuard {
  constructor(
    private guildService: GuildService,
    private router: Router,
    private toastr: ToastrService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const guildId = route.parent?.paramMap.get('id') || route.paramMap.get('id');
    if (!guildId) {
      this.router.navigate(['/']); // Redirect if guild ID is not found
      return false;
    }

    return this.guildService.getGuildData(guildId).pipe(
      map(guild => {
        const hasPermission = this.checkLimits(guild); // Implement this method based on your requirements
        if (!hasPermission) {
          this.toastr.error('You have reached the maximum number of custom signup templates.');
          return false;
        }
        return true;
      }),
      catchError((error) => {
        this.router.navigate(['/error']); // Handle potential errors such as network issues
        return of(false);
      })
    );
  }

  private checkLimits(guild: BotGuild): boolean {
    // Define your logic to determine if the user has the correct permissions
    return guild.signup_templates.length < guild.limits.max_custom_templates || guild.has_premium;
  }
}
